export default __webpack_public_path__ + "static/media/product_test_choices_device.58d299a8.jpg";